import { Component, OnInit, Input } from '@angular/core';
import { Router} from "@angular/router";
import { NavigationProvider } from '@nrwl/navigation-abstract';

@Component({
  selector: 'nrwl-active-test-license-button',
  templateUrl: './active.test.license.button.component.html',
  styleUrls: ['../active.test.wizard.style.scss']
})
export class ActiveTestLicenseButtonComponent implements OnInit {
  @Input() wizardCtrl: any;
  @Input() step: any;
  licenses: any;
  constructor(private readonly navigator: NavigationProvider) { }

  ngOnInit() {
    this.licenses = this.wizardCtrl.licenses;
  }

  isLicenseExceeded() {
    return this.licenses.max > 0 && (this.licenses.max <= this.licenses.inUse);
  }

  navToLicensePage() {
    this.navigator.navigateToDashboard(["licenses"]);
  }

}
